const avatar = {
  styleOverrides: {
    rounded: {
      borderRadius: '8px'
    }
  }
};

export default avatar;
